import { memo } from 'react';

import { type IconComponent } from '@air/design-icons';
import { cn } from '@air/utils-tailwind';

import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';

export type NotificationIconBadgeProps = {
  icon: IconComponent;
  textClassName?: string;
  'data-testid'?: string;
};

export const NotificationIconBadge = memo(
  ({ icon: Icon, textClassName, 'data-testid': dataTestId }: NotificationIconBadgeProps) => {
    const { ui2026 } = useTemporaryFeatureFlags();

    if (ui2026) {
      return (
        <div
          className="flex size-8 items-center justify-center rounded-8 ads:bg-subtle bg-gray-3 ads:text-icon-subtle text-gray-9"
          data-testid={dataTestId}
        >
          <Icon aria-hidden size="sm" />
        </div>
      );
    }

    return (
      <div
        className={cn(
          'flex h-8 w-8 items-center justify-center rounded-full ads:bg-ads-gray-4 bg-gray-4',
          textClassName,
        )}
      >
        <Icon size="md" />
      </div>
    );
  },
);

NotificationIconBadge.displayName = 'NotificationIconBadge';
